<div class="order__item--variations">
    <div class="row header-row">
        <div class="col-md-4 col-12 variation-header">variation</div>
        <div class="col-md-3 col-12 variation-header">price per unit</div>
        <div class="col-md-2 col-12 variation-header">quantity</div>
        <div class="col-md-3 col-12 variation-header">total</div>

    </div>

    <div *ngFor="let item of variations" class="row">
        <div class="col-md-4 col-12 item"><span class="variation-header">variation</span>{{item.label}}</div>
        <div class="col-md-3 col-12 item"><span class="variation-header">price per unit</span>
            <app-product-price [price]="item.price"
                               [originalPrice]="item.originalPrice"
                               [discount]="orderItem.productDiscount" fontSize="font-6" orientation="horizontal"></app-product-price>
        </div>
         <div class="col-md-2 col-12 item"><span class="variation-header">quantity</span>{{item.quantity}} <customization-info [orderItem]="orderItem"></customization-info></div>
        <div class="col-md-3 col-12 item"><span class="variation-header">total</span><span class="price"><app-currency-price [price]="item.totalCost" [currency]="orderItem.product.currency"></app-currency-price></span></div>
    </div>
</div>
